import * as React from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";

import "./property-wizard.scss";
import "./results-pg.scss";

import {cs}               from "@Common/react/chain-services";
import {UseState}         from "@Common/react/use-state";
import {consumeContext}   from "@Common/react/context";
import {isDevXd}          from "@Common/ui-components/debug/is-dev";
import {ButtonSpinner}    from "@Common/ui-components/loading-spinners/button-spinner";
import {ScreenLoader}     from "@Common/ui-components/loading-spinners/screen-loader";
import {AiSparklesSvg}    from "ai-banner/ai-sparkles-svg";
import {FieldResultsCard} from "./field-results-card";
import { Load2 } from "@Common/react/load2";

export const ResultsPage = ({
    idOrder,
    item,
    propertyData,
    propertyWizardData,
    agregateTextualSummary,
    eligableContentFields,
    eligableSpecFields
}) => cs(
    consumeContext("apis"),
    ["loading", ({}, next) => UseState({
        initValue: false,
        next
    })],
    ["handleBackToEdit", ({apis, loading}, next) => next(async () => {
        // TODO: replace with a custom alert modal
        let text = "This will clear the results on this page. Are you sure you want to go back to the edit page?"
        if ( confirm(text) ) {
            loading.onChange(true);
            await apis.next.gpt.savePropertyWizardData({
                idOrder: parseInt(idOrder),
                data: {...propertyData.value, aggregateSummary: null},
            });
            await propertyWizardData.reload();
            loading.onChange(false);
        }
    })],
    ["fieldSuggestions", ({}, next) => UseState({
        initValue: [],
        next
    })],
    // TODO: We're going to have to save fieldSuggestions to DB to avoid repeatedly making calls on component mount
    // This means making another column on xbase.property_wizard_data
    // Also we can go back to pg.1 & back again to pg.2 to see the field suggestions without clearing the data
    (({fieldSuggestions, apis}, next) => Load2({
        _key: agregateTextualSummary.value,
        fetch: async () => {
            try {
                const results = await Promise.all(
                    [...eligableContentFields, ...eligableSpecFields].map(async (field) => {
                        let responses = await apis.next.gpt.generateFieldSuggestions({
                            idOrder: parseInt(idOrder),
                            numOfSuggestions: 3,
                            idProductType: parseInt(item.idProductType),
                            field: {
                                idPrimary: field.idPrimary,
                                fieldKey: field.fieldKey,
                                displayLabel: field.displayLabel,
                                maxLength: field.maxLength,
                                enableLimitOverride: field.enableLimitOverride,
                            },
                        });
                        return responses;
                    })
                );
                fieldSuggestions.onChange(results.flat());
            } catch (error) {
                // TODO: Implement a custom error handler
                console.error("Error fetching property wizard data:", error);
            }
        },
        next
    })),
    (({fieldSuggestions}, next) => next( console.log("fieldSuggestions: ", fieldSuggestions) )),


    ({loading, handleBackToEdit, fieldSuggestions}) => (
        <div className="results-page-t87">
            {loading.value ?
            // TODO: Replace loader with AI twinkle
                <div className="page-loader"><ScreenLoader loaderColor="#6937B7"/></div>
            : <>
                <div className="back-to-edit"
                    onClick={() => handleBackToEdit()}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                    Edit Property Context
                </div>
                {/* Leaving for now while building. Nice to have info redily avainalble in display */}
                {/* <div className="summary-container">
                    <div className="summary-text">
                        {agregateTextualSummary.value}
                    </div>
                </div> */}
                {[...eligableContentFields, ...eligableSpecFields].map( field =>
                    <FieldResultsCard
                        idOrder={idOrder}
                        item={item}
                        field={field}
                        initFieldSuggestions={fieldSuggestions.value.filter(suggestion =>
                            suggestion.idPrimary === field.idPrimary
                        )}
                    />
                )}
            </>}
        </div>
    )
)